/** Текст ошибки из ответа сервера (error / первая ошибка валидации) или запасной текст */
export function errorText(err, fallback) {
  const data = err?.response?.data;
  return data?.error || data?.details?.[0]?.message || data?.message || fallback;
}
